var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCxLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "logo",
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 547 98",
    width: 240,
    height: 40,
    style: {
      enableBackground: "new 0 0 547 98"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .logo-color {\n            fill: #1474ff;\n        }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "logo-color",
    d: "M204.8,60.5v35.2h-16.5V0.8h36.3c10.6,0,19,2.8,25.3,8.3c6.2,5.5,9.4,12.8,9.4,21.9c0,9.3-3.1,16.5-9.2,21.7         c-6.1,5.2-14.7,7.8-25.6,7.8H204.8z M204.8,47.2h19.8c5.9,0,10.3-1.4,13.4-4.1s4.6-6.7,4.6-12c0-5.1-1.6-9.2-4.7-12.3         c-3.1-3.1-7.4-4.6-12.9-4.7h-20.3V47.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo-color",
    d: "M366.1,95.7h-16.4V53.6h-42.4v42.1h-16.5V0.8h16.5v39.5h42.4V0.8h16.4V95.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "logo-color",
    d: "M145.4,95.7H129V0.8h16.4V95.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 0.8,
    className: "logo-color",
    width: 16.5,
    height: 16.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "logo-color",
    d: "M430.4,95.7H414V0.8h16.4V95.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.6,
    y: 0.8,
    className: "logo-color",
    width: 16.5,
    height: 16.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "logo-color",
    d: "M88.9,15.3c-4.2-4.6-9.4-8.3-15.3-10.8c-6.6-2.9-14.1-4.3-22.3-4.3c-9.7,0-18.6,2.1-26.4,6.3         c-7.7,4.2-13.9,10-18.3,17.4C2.2,31.2,0,39.7,0,49c0,9.3,2.2,17.8,6.7,25.2c4.4,7.4,10.6,13.2,18.3,17.4h0         c7.8,4.2,16.6,6.3,26.2,6.3c8.2,0,15.7-1.5,22.4-4.3c6-2.6,11.1-6.3,15.4-11L77.4,71.8C70.6,79,62.2,82.6,52.5,82.6         c-6.4,0-12.3-1.4-17.4-4.3c-5.1-2.9-9.1-6.9-12-12c-2.8-5.1-4.3-10.9-4.3-17.4s1.4-12.3,4.3-17.4c2.9-5.1,6.9-9.1,12-12         c5.1-2.8,10.9-4.3,17.4-4.3c9.7,0,18.1,3.6,24.9,10.7L88.9,15.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "logo-color",
    points: "486.3,95.8 510.6,56.2 546,0.8 525.5,0.8 501.4,40.1 465.9,95.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "logo-color",
    points: "510.6,56.2 515.7,48.3 510.4,40.1 486.3,0.8 465.9,0.8 501.1,56 505.9,63.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "logo-color",
    points: "524,61.3 514.2,77.3 525.5,95.8 546,95.8  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "logo-color",
    d: "M515.7,48.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo-color",
    d: "M524,61.3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCxLogo);
export default __webpack_public_path__ + "static/media/cxLogo.d0c7a89454c9b4c13bf4e86a87112ea1.svg";
export { ForwardRef as ReactComponent };